export const en: Record<string, string> = {
  'voiceCalls.title': 'Phone calls',
  'voiceCalls.description': 'Call history, conversations and tool results. All times are Europe/Vienna.',
  'voiceCalls.details': 'Call details',
  'voiceCalls.back': 'Back to calls',
  'voiceCalls.search': 'Search',
  'voiceCalls.searchLabel': 'Search calls',
  'voiceCalls.searchPlaceholder': 'Call ID, phone number or first message',
  'voiceCalls.loading': 'Loading calls…',
  'voiceCalls.loadingDetail': 'Loading call…',
  'voiceCalls.loadError': 'Could not load calls. Try refreshing.',
  'voiceCalls.detailError': 'Could not load this call. Check the URL or try refreshing.',
  'voiceCalls.empty': 'No calls found.',
  'voiceCalls.unknownCaller': 'Unknown / private number',
  'voiceCalls.call': 'Call',
  'voiceCalls.caller': 'Caller',
  'voiceCalls.started': 'Started (Europe/Vienna)',
  'voiceCalls.firstSeen': 'First seen',
  'voiceCalls.duration': 'Duration',
  'voiceCalls.firstMessage': 'First message',
  'voiceCalls.tools': 'Tools',
  'voiceCalls.failedCount': '{count} failed',
  'voiceCalls.pending': 'Report pending',
  'voiceCalls.complete': 'Report received',
  'voiceCalls.endedReason': 'End reason',
  'voiceCalls.userTurns': 'Caller turns',
  'voiceCalls.bookings': 'Bookings',
  'voiceCalls.conversation': 'Conversation',
  'voiceCalls.noConversation': 'No conversation recorded.',
  'voiceCalls.noTools': 'No tools recorded.',
  'voiceCalls.role.user': 'Caller',
  'voiceCalls.role.assistant': 'Assistant',
  'voiceCalls.arguments': 'Arguments',
  'voiceCalls.result': 'Result',
  'voiceCalls.failed': 'Failed',
  'voiceCalls.succeeded': 'Succeeded',
  'voiceCalls.unknownStatus': 'Result pending',
  'voiceCalls.toolLink': 'Link to tool',
  'voiceCalls.recording': 'Recording',
  'voiceCalls.loadRecording': 'Load recording',
  'voiceCalls.reloadRecording': 'Reload recording',
  'voiceCalls.loadingRecording': 'Loading recording…',
  'voiceCalls.noRecording': 'No recording available.',
  'voiceCalls.recordingError': 'Could not load the recording. Try reloading it.',
  'voiceCalls.playbackError': 'Playback failed. Reload the recording to get a fresh link.',
  'voiceCalls.recordingHint': 'Load a fresh playback link when you want to listen.',
  'voiceCalls.recordingTrack': 'Audio track',
  'voiceCalls.track.combined': 'Combined',
  'voiceCalls.track.caller': 'Caller',
  'voiceCalls.track.assistant': 'Assistant',
  'voiceCalls.track.stereo': 'Stereo',
  'voiceCalls.expires': 'Link expires: {time}',
  'voiceCalls.metadata': 'Call metadata',
  'voiceCalls.cost': 'Cost (USD)',
  'voiceCalls.model': 'Model',
  'voiceCalls.voice': 'Voice',
  'voiceCalls.transcriber': 'Transcriber',
};
export const de: Record<string, string> = {
  'voiceCalls.title': 'Telefonate',
  'voiceCalls.description': 'Anrufhistorie, Gespräche und Tool-Ergebnisse. Alle Zeiten in Europe/Vienna.',
  'voiceCalls.details': 'Anrufdetails',
  'voiceCalls.back': 'Zurück zu Telefonaten',
  'voiceCalls.search': 'Suchen',
  'voiceCalls.searchLabel': 'Telefonate suchen',
  'voiceCalls.searchPlaceholder': 'Anruf-ID, Telefonnummer oder erste Nachricht',
  'voiceCalls.loading': 'Telefonate werden geladen…',
  'voiceCalls.loadingDetail': 'Anruf wird geladen…',
  'voiceCalls.loadError': 'Telefonate konnten nicht geladen werden. Bitte aktualisieren.',
  'voiceCalls.detailError': 'Dieser Anruf konnte nicht geladen werden. URL prüfen oder aktualisieren.',
  'voiceCalls.empty': 'Keine Telefonate gefunden.',
  'voiceCalls.unknownCaller': 'Unbekannt / unterdrückt',
  'voiceCalls.call': 'Anruf',
  'voiceCalls.caller': 'Anrufer',
  'voiceCalls.started': 'Beginn (Europe/Vienna)',
  'voiceCalls.firstSeen': 'Erstmals erfasst',
  'voiceCalls.duration': 'Dauer',
  'voiceCalls.firstMessage': 'Erste Nachricht',
  'voiceCalls.tools': 'Tools',
  'voiceCalls.failedCount': '{count} fehlgeschlagen',
  'voiceCalls.pending': 'Bericht ausständig',
  'voiceCalls.complete': 'Bericht erhalten',
  'voiceCalls.endedReason': 'Beendigungsgrund',
  'voiceCalls.userTurns': 'Gesprächsbeiträge',
  'voiceCalls.bookings': 'Buchungen',
  'voiceCalls.conversation': 'Gespräch',
  'voiceCalls.noConversation': 'Kein Gespräch gespeichert.',
  'voiceCalls.noTools': 'Keine Tools gespeichert.',
  'voiceCalls.role.user': 'Anrufer',
  'voiceCalls.role.assistant': 'Assistent',
  'voiceCalls.arguments': 'Argumente',
  'voiceCalls.result': 'Ergebnis',
  'voiceCalls.failed': 'Fehlgeschlagen',
  'voiceCalls.succeeded': 'Erfolgreich',
  'voiceCalls.unknownStatus': 'Ergebnis ausständig',
  'voiceCalls.toolLink': 'Link zum Tool',
  'voiceCalls.recording': 'Aufzeichnung',
  'voiceCalls.loadRecording': 'Aufzeichnung laden',
  'voiceCalls.reloadRecording': 'Aufzeichnung neu laden',
  'voiceCalls.loadingRecording': 'Aufzeichnung wird geladen…',
  'voiceCalls.noRecording': 'Keine Aufzeichnung verfügbar.',
  'voiceCalls.recordingError': 'Aufzeichnung konnte nicht geladen werden. Bitte erneut laden.',
  'voiceCalls.playbackError': 'Wiedergabe fehlgeschlagen. Aufzeichnung für einen neuen Link erneut laden.',
  'voiceCalls.recordingHint': 'Zum Anhören einen aktuellen Wiedergabelink laden.',
  'voiceCalls.recordingTrack': 'Audiospur',
  'voiceCalls.track.combined': 'Kombiniert',
  'voiceCalls.track.caller': 'Anrufer',
  'voiceCalls.track.assistant': 'Assistent',
  'voiceCalls.track.stereo': 'Stereo',
  'voiceCalls.expires': 'Link gültig bis: {time}',
  'voiceCalls.metadata': 'Anrufdaten',
  'voiceCalls.cost': 'Kosten (USD)',
  'voiceCalls.model': 'Modell',
  'voiceCalls.voice': 'Stimme',
  'voiceCalls.transcriber': 'Transkription',
};
